document.addEventListener('DOMContentLoaded', () => {
    new Swiper(".swiper-conf", {
        spaceBetween: 5,
        centeredSlides: false,
        slidesPerView: 1.5,
        loop: false,
        slideToClickedSlide: true,

        // enable accessibility
        a11y: true,
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        freeMode: false
    });
});

const carouselButtons = document.querySelectorAll(".js-carousel-link");
carouselButtons.forEach((button) => {
    const tag = JSON.parse(button.dataset.tag)
    button.addEventListener("click", () => Tms.link(tag))
});

const callbackButton = window.innerWidth < myshop.ob1.breakpoints.xl ?
    document.getElementById("mobile-callback-block")
    : document.getElementById("desktop-callback-block");
const callbackButtonOffset = callbackButton.offsetParent.offsetTop
    + callbackButton.offsetTop
    + callbackButton.offsetHeight / 2;
let fabIsDisplayed = false;
window.addEventListener("scroll", () => {
    if (window.scrollY > callbackButtonOffset) {
        if (!fabIsDisplayed) {
            document.getElementById("fab").classList.remove("d-none");
            fabIsDisplayed = true;
        }
    }
});

document.querySelectorAll(".msh-timer-th").forEach(makeTimer);
